import { Module } from '@nestjs/common';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { SupabaseModule } from './supabase/supabase.module';
import { MysqlModule } from './mysql/mysql.module';
import { AuthModule } from './auth/auth.module';
import { AttachmentsModule } from './attachments/attachments.module';
import { ClientsModule } from './clients/clients.module';
import { CompaniesModule } from './companies/companies.module';
import { FinancialsModule } from './financials/financials.module';
import { LeadsModule } from './leads/leads.module';
import { MonitoringsModule } from './monitorings/monitorings.module';
import { ProposalsModule } from './proposals/proposals.module';
import { SalesModule } from './sales/sales.module';
import { UsersModule } from './users/users.module';
import { ConfigModule } from '@nestjs/config';

@Module({
  imports: [
    ConfigModule.forRoot({ isGlobal: true }),
    SupabaseModule,
    MysqlModule,
    AuthModule,
    AttachmentsModule,
    ClientsModule,
    CompaniesModule,
    FinancialsModule,
    LeadsModule,
    MonitoringsModule,
    ProposalsModule,
    SalesModule,
    UsersModule,
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
